import {authStorageService} from '../services/service-factory';

export default {
  data: function() {
    return {
      authStorageService: undefined
    };
  },
  created: function() {
    this.authStorageService = authStorageService;
  }
};